export default __webpack_public_path__ + "9c41c3eb27d08b1deb81d9721a210aa5.ttf";